export const isDraggingBodyClass: string = 'is-dragging-tree-item';
